<script lang="ts" setup>
import type { Data, FAQ } from '~~/server/api/faq/category/[slug]'

export interface PagesFaqSubcategoriesProps {
    faq: FAQ[]
    children: Data[]
    categorySlug: string
}

const props = defineProps<PagesFaqSubcategoriesProps>()
</script>
<template>
  <div class="faq-list">
    <FaqListQuestions
      v-if="props.faq.length > 0"
      :faq="props.faq"
      :category-slug="props.categorySlug"
      class="mb-5"
      :class="{ 'w-100 d-inline-block': props.children.length === 0 }"
    />

    <template
      v-for="(category, index) in props.children"
      :key="`faqcdi-${index}`"
    >
      <section class="faq-list-item mb-5">
        <h3 class="fs-normal fw-bolder text-uppercase mb-4">
          {{ category.title }}
        </h3>

        <FaqListQuestions
          v-if="category.faq.length > 0"
          :faq="category.faq"
          :category-slug="category.slug"
        />

        <FaqListChildren
          v-if="category.children.length > 0"
          :children="category.children"
        >
          <template #icon>
            <svg
              class="d-block ms-4"
              width="10"
              height="10"
            >
              <use xlink:href="#angle-right" />
            </svg>
          </template>
        </FaqListChildren>
      </section>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import './FaqList.scss';
</style>
